import React, { ReactNode } from "react";
import { defaultTemplate } from "@hoc";

interface EmptyStateProps {
	styles: {
		wrapperStyle: string;
		iconStyle?: string;
		imgStyle?: string;
		imgSrc?: string;
		imgAlt?: string;
		title?: ReactNode | string;
	};
	children?: ReactNode | JSX.Element;
}

export default defaultTemplate(function EmptyState(props: EmptyStateProps) {
	const {
		styles: { wrapperStyle, iconStyle, imgStyle, imgSrc, imgAlt, title },
	} = props;

	const isImageAvailable =
		imgStyle != null && imgSrc != null && imgAlt != null;

	return (
		<div className={wrapperStyle}>
			{title}
			{iconStyle != null && <i className={iconStyle} />}
			{isImageAvailable && (
				<div className={imgStyle}>
					<img src={imgSrc} alt={imgAlt} />
				</div>
			)}
			<div>{props.children}</div>
		</div>
	);
});
